"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.options = {
    afterMount: null,
    afterRender: null,
    afterUpdate: null,
    beforeRender: null,
    beforeUnmount: null,
    createVNode: null,
    findDOMNodeEnabled: false,
    recyclingEnabled: false,
    roots: []
};



//////////////////
// WEBPACK FOOTER
// ./~/inferno/dist/core/options.js
// module id = 3
// module chunks = 0